// extracted by mini-css-extract-plugin
export default {"wrapper":"FallbackUI_wrapper__mV6zU","title":"FallbackUI_title__zSmF-","subtitle":"FallbackUI_subtitle__rTRM+"};